class FostrAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.originalScrollPosition = this.offsetTop;
    this.animationDuration = this.dataset.animateDuration || '3s';

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    const observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
    observer.observe(this);

    this.blocks = Array.from(this.querySelectorAll('.announcement-bar__block'));
    this.blocks.forEach((block, index) => {
      block.style.animationDuration = this.animationDuration;
      block.addEventListener('mouseenter', () => this.pauseAnimation(index));
      block.addEventListener('mouseleave', () => this.resumeAnimation(index));
    });

    this.currentIndex = 0;
    this.startAnimation();
  }

  handleIntersection(entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        document.body.classList.add('fostr-announcement-bar--isVisible');
      } else {
        document.body.classList.remove('fostr-announcement-bar--isVisible');
        this.querySelector('.announcement-bar--no-animation-onload')?.classList.remove('announcement-bar--no-animation-onload')
      }
    }
  }

  startAnimation() {
    this.blocks[this.currentIndex].classList.add('active');
    this.currentIndex = (this.currentIndex + 1) % this.blocks.length;
    setTimeout(() => {
      this.blocks.forEach((block) => {
        block.classList.remove('active');
      });
      this.startAnimation();
    }, parseFloat(this.animationDuration) * 1000);
  }

  pauseAnimation(index) {
    this.blocks[index].classList.add('paused');
  }

  resumeAnimation(index) {
    this.blocks[index].classList.remove('paused');
  }
}

customElements.define('fostr-announcement-bar', FostrAnnouncementBar);
